import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-info-circle text-warningX me-1" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Jetzt deine kostenlose Probestunde einsetzen:", -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_ctx.hasTrial)
    ? (_openBlock(), _createBlock(_component_Alert, {
        key: 0,
        type: "success"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createElementVNode("a", { href: _ctx.regionDetailLinkUrl }, [
            _hoisted_4,
            _createTextVNode(" Kurse in " + _toDisplayString(_ctx.regionLinkable.name) + " ansehen!", 1)
          ], 8, _hoisted_3)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}